import { render, staticRenderFns } from "./SentInfoControl.vue?vue&type=template&id=2949b4fd"
import script from "./SentInfoControl.vue?vue&type=script&lang=js"
export * from "./SentInfoControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports